import styled from "styled-components";


const LinkContainer = styled.div`
  width: 100%;
  margin-top: 40px;
  /* border: 2px solid lightblue; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* position: relative; */
  overflow: hidden;
`;

export default LinkContainer;
